/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Validation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepKernel = require('deep-kernel');

var _deepKernel2 = _interopRequireDefault(_deepKernel);

var _ObjectToJoi = require('./ObjectToJoi');

var _ValidationSchemaNotFoundException = require('./Exception/ValidationSchemaNotFoundException');

var _InvalidJoiSchemaException = require('./Exception/InvalidJoiSchemaException');

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _ObjectValidationFailedException = require('./Exception/ObjectValidationFailedException');

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Validation engine
 */
let Validation = exports.Validation = function (_Kernel$ContainerAwar) {
  _inherits(Validation, _Kernel$ContainerAwar);

  /**
   * @param {Array} models
   * @param {Boolean} forcePartitionField
   * @param {String[]} nonPartitionedModels
   */
  function Validation() {
    let models = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let forcePartitionField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let nonPartitionedModels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, Validation);

    var _this = _possibleConstructorReturn(this, (Validation.__proto__ || Object.getPrototypeOf(Validation)).call(this));

    _this._forcePartitionField = forcePartitionField;
    _this._nonPartitionedModels = nonPartitionedModels || [];

    _this._schemas = _this._rawModelsToSchemas(models);
    return _this;
  }

  /**
   * @param {Runtime} lambdaRuntime
   * @param {String} schemaName
   * @param {Function} cb
   * @returns {Validation}
   */


  _createClass(Validation, [{
    key: 'validateRuntimeInput',
    value: function validateRuntimeInput(lambdaRuntime, schemaName, cb) {
      if (!this.hasSchema(schemaName)) {
        lambdaRuntime.createError(new _ValidationSchemaNotFoundException.ValidationSchemaNotFoundException(schemaName)).send();
        return this;
      }

      let validationResult = this.validate(schemaName, lambdaRuntime.request.data, true);

      if (!validationResult.error) {
        cb(validationResult.value);
        return this;
      }

      lambdaRuntime.createError(validationResult.error).send();

      return this;
    }

    /**
     * @param {String} schemaName
     * @param {*} valueObject
     * @param {Boolean} returnRaw
     * @returns {*}
     */

  }, {
    key: 'validate',
    value: function validate(schemaName, valueObject) {
      let returnRaw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      let validationSchema = this.getSchema(schemaName);

      let result = _joi2.default.validate(valueObject, validationSchema, {
        stripUnknown: true,
        convert: true,
        abortEarly: false
      });

      if (returnRaw) {
        return result;
      }

      if (result.error) {
        throw new _ObjectValidationFailedException.ObjectValidationFailedException(schemaName, result.error);
      }

      return result.value;
    }

    /**
     * @todo: find a better way to inject libraries...
     *
     * @param {Function} cb
     * @returns {Object}
     */

  }, {
    key: 'schemaFromValidationCb',
    value: function schemaFromValidationCb(cb) {
      return cb(_joi2.default);
    }

    /**
     * @returns {Object[]}
     */

  }, {
    key: 'setSchemaRaw',


    /**
     * @param {String} schemaName
     * @param {Object} schema
     * @returns {Validation}
     */
    value: function setSchemaRaw(schemaName, schema) {
      this._schemas[schemaName] = Validation.normalizeSchema(schema);

      return this;
    }

    /**
     * @param {String} schemaName
     * @param {Object} schema
     * @returns {Validation}
     */

  }, {
    key: 'setSchema',
    value: function setSchema(schemaName, schema) {
      if (!schema.isJoi) {
        throw new _InvalidJoiSchemaException.InvalidJoiSchemaException(schemaName);
      }

      this._schemas[schemaName] = schema;

      return this;
    }

    /**
     * @param {String} schemaName
     * @param {Object} schema
     * @returns {Validation}
     */

  }, {
    key: 'setGuessSchema',
    value: function setGuessSchema(schemaName, schema) {
      if (typeof schema === 'function') {
        schema = this.schemaFromValidationCb(schema);
      }

      let setSchemaMethod = schema.isJoi ? 'setSchema' : 'setSchemaRaw';

      return this[setSchemaMethod](schemaName, schema);
    }

    /**
     * @param {String} schemaName
     * @returns {Boolean}
     */

  }, {
    key: 'hasSchema',
    value: function hasSchema(schemaName) {
      return typeof this._schemas[schemaName] !== 'undefined';
    }

    /**
     * @param {String} schemaName
     * @returns {Object}
     */

  }, {
    key: 'getSchema',
    value: function getSchema(schemaName) {
      if (!this.hasSchema(schemaName)) {
        throw new _ValidationSchemaNotFoundException.ValidationSchemaNotFoundException(schemaName);
      }

      let schema = this._schemas[schemaName];

      // Let's assume it's an path while lazy loading in backend context
      if (typeof schema === 'string') {
        return this.setGuessSchema(schemaName, require(schema)).getSchema(schemaName);
      }

      return schema;
    }

    /**
     * Booting a certain service
     *
     * @param {Kernel} kernel
     * @param {Function} callback
     */

  }, {
    key: 'boot',
    value: function boot(kernel, callback) {
      this._nonPartitionedModels = kernel.config.nonPartitionedModels || [];
      this._schemas = this._rawModelsToSchemas(kernel.config.models);

      let universalRequire = new _deepCore2.default.Generic.UniversalRequire();
      let remainingSchemas = kernel.config.validationSchemas.length;

      // Load custom schemas
      kernel.config.validationSchemas.forEach(schemaName => {
        let relativeSchemaPath = _path2.default.join(_deepCore2.default.AWS.Lambda.Runtime.VALIDATION_SCHEMAS_DIR, `${schemaName}.js`);

        if (kernel.isBackend) {
          this._schemas[schemaName] = _path2.default.join(process.cwd(), relativeSchemaPath);

          remainingSchemas--;
        } else {
          let schemaUrl = _path2.default.join(_path2.default.sep, relativeSchemaPath);

          universalRequire.require(schemaUrl, (error, schemaObj) => {

            // @todo: abstract it somehow?
            if (error) {
              console.error(`Error while loading schema ${schemaName}: ${error}`);
            } else {
              this.setGuessSchema(schemaName, schemaObj);
            }

            remainingSchemas--;
          });
        }
      });

      let checkRemainingSchemas = onFail => {
        if (remainingSchemas <= 0) {
          callback();
        } else {
          setTimeout(() => {
            onFail(onFail);
          }, 50);
        }
      };

      checkRemainingSchemas(checkRemainingSchemas);
    }

    /**
     * @param {Array} rawModels
     * @returns {Object}
     * @private
     */

  }, {
    key: '_rawModelsToSchemas',
    value: function _rawModelsToSchemas(rawModels) {
      let modelsSchema = {};

      for (let modelKey in rawModels) {
        if (!rawModels.hasOwnProperty(modelKey)) {
          continue;
        }

        let backendModels = rawModels[modelKey];

        for (let schemaName in backendModels) {
          if (!backendModels.hasOwnProperty(schemaName)) {
            continue;
          }

          let schema = backendModels[schemaName];

          // @todo: move this sh*t into DB somehow...
          schema.Id = schema.Id || 'timeUUID';

          modelsSchema[schemaName] = Validation.normalizeSchema(schema);

          if (!schema.AccountId && this._usePartitionField && this.isPartitionedModel(schemaName)) {
            modelsSchema[schemaName] = modelsSchema[schemaName].keys({
              AccountId: _joi2.default.string().default('anonymous')
            });
          }
        }
      }

      return modelsSchema;
    }

    /**
     * @returns {Boolean}
     * @private
     */

  }, {
    key: 'isPartitionedModel',


    /**
     * @param {String} modelName
     * @returns {Boolean}
     */
    value: function isPartitionedModel(modelName) {
      let modelIndex = this._nonPartitionedModels.indexOf(modelName);

      if (this.kernel) {
        return this.kernel.accountMicroservice && modelIndex === -1;
      } else {
        return modelIndex === -1;
      }
    }

    /**
     * @param {Object} rawSchema
     * @returns {Object}
     */

  }, {
    key: 'schemas',
    get: function get() {
      return this._schemas;
    }

    /**
     * @returns {String[]}
     */

  }, {
    key: 'schemasNames',
    get: function get() {
      return Object.keys(this._schemas);
    }
  }, {
    key: '_usePartitionField',
    get: function get() {
      return this._forcePartitionField || this.kernel && this.kernel.accountMicroservice;
    }
  }], [{
    key: 'normalizeSchema',
    value: function normalizeSchema(rawSchema) {
      return new _ObjectToJoi.ObjectToJoi(rawSchema).transform();
    }
  }]);

  return Validation;
}(_deepKernel2.default.ContainerAware);


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Validation.js
// module id = 465
// module chunks = 0